<p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [draggable]="false"
          [closable]="true" [style]="{ width: '520px' }" [breakpoints]="{ '575px': '95vw' }">
    <ng-template pTemplate="header">
        <div class="flex items-center">
            <i class="pi pi-shield text-primary mr-2"></i>
            <span class="font-semibold">{{ 'COMMON.RSA_MIGRATION.TITLE' | translate }}</span>
        </div>
    </ng-template>

    <!-- Calisiyor (kosu kisa surerse hic gorunmez) -->
    <div *ngIf="stage === 'busy'" class="flex items-center gap-3">
        <i class="pi pi-spin pi-spinner text-primary"></i>
        <span class="text-sm">{{ 'COMMON.RSA_MIGRATION.BUSY' | translate }}</span>
    </div>

    <!-- Yeni PIN (cihazda eski anahtar var; eski PIN sorulmaz) -->
    <div *ngIf="stage === 'pin'" class="flex flex-col gap-3">
        <p class="text-sm m-0">{{ 'COMMON.RSA_MIGRATION.PIN_BODY' | translate }}</p>
        <input pInputText type="password" inputmode="numeric" maxlength="6" autocomplete="new-password" name="rsaMigPin"
               [placeholder]="'COMMON.RSA_MIGRATION.PIN_LABEL' | translate" [(ngModel)]="pin" (ngModelChange)="pin = digits($event)" />
        <input pInputText type="password" inputmode="numeric" maxlength="6" autocomplete="new-password" name="rsaMigPinConfirm"
               [placeholder]="'COMMON.RSA_MIGRATION.PIN_CONFIRM_LABEL' | translate" [(ngModel)]="pinConfirm"
               (ngModelChange)="pinConfirm = digits($event)" />
        <p-message *ngIf="inlineKey" severity="warn" [text]="inlineKey | translate" />
    </div>

    <!-- Yedegin yeri: sunucu, dosya ya da ikisi -->
    <div *ngIf="stage === 'place'" class="flex flex-col gap-3">
        <p class="text-sm m-0">{{ 'COMMON.RSA_MIGRATION.PLACE_BODY' | translate }}</p>
        <div class="flex items-center gap-2">
            <p-radioButton name="rsaMigPlace" value="server" [(ngModel)]="place" inputId="rsaMigPlaceServer" />
            <label for="rsaMigPlaceServer" class="cursor-pointer">{{ 'COMMON.RSA_MIGRATION.PLACE_SERVER' | translate }}</label>
        </div>
        <div class="flex items-center gap-2">
            <p-radioButton name="rsaMigPlace" value="download" [(ngModel)]="place" inputId="rsaMigPlaceDownload" />
            <label for="rsaMigPlaceDownload" class="cursor-pointer">{{ 'COMMON.RSA_MIGRATION.PLACE_DOWNLOAD' | translate }}</label>
        </div>
        <div class="flex items-center gap-2">
            <p-radioButton name="rsaMigPlace" value="both" [(ngModel)]="place" inputId="rsaMigPlaceBoth" />
            <label for="rsaMigPlaceBoth" class="cursor-pointer">{{ 'COMMON.RSA_MIGRATION.PLACE_BOTH' | translate }}</label>
        </div>
    </div>

    <!-- Sunucudaki v5 yedegin PIN'i ya da kurtarma kodu -->
    <div *ngIf="stage === 'secret'" class="flex flex-col gap-3">
        <p class="text-sm m-0">{{ 'COMMON.RSA_MIGRATION.SECRET_BODY' | translate }}</p>
        <input pInputText type="password" maxlength="40" autocomplete="off" name="rsaMigSecret"
               [placeholder]="'COMMON.RSA_MIGRATION.SECRET_LABEL' | translate" [(ngModel)]="secret" />
        <p-message *ngIf="inlineKey" severity="warn" [text]="inlineKey | translate" />
    </div>

    <!-- Yeni anahtar dosyasi: indir, kaydet, geri sec (FileProof) -->
    <div *ngIf="stage === 'file'" class="flex flex-col gap-3">
        <p class="text-sm m-0">{{ (purge ? 'COMMON.RSA_MIGRATION.FILE_PURGE_BODY' : 'COMMON.RSA_MIGRATION.FILE_BODY') | translate }}</p>
        <div class="flex flex-wrap gap-2">
            <p-button [label]="'COMMON.RSA_MIGRATION.BTN_DOWNLOAD' | translate" icon="pi pi-download"
                      [severity]="downloaded ? 'secondary' : 'primary'" (onClick)="download()" />
            <input #proofInput type="file" accept=".key" class="hidden" (change)="onFile($event)" />
            <p-button [label]="'COMMON.RSA_MIGRATION.BTN_CHOOSE' | translate" icon="pi pi-folder-open"
                      [disabled]="!downloaded" (onClick)="proofInput.click()" />
        </div>
        <p-message *ngIf="inlineKey" severity="warn" [text]="inlineKey | translate" />
    </div>

    <!-- Sonuc -->
    <div *ngIf="stage === 'message' && messageKey" class="flex flex-col gap-3">
        <p-message [severity]="messageSeverity" [text]="messageKey | translate" />
    </div>

    <ng-template pTemplate="footer">
        <div class="flex flex-wrap justify-end gap-2">
            <p-button *ngIf="stage !== 'message' && stage !== 'busy'" [label]="'COMMON.RSA_MIGRATION.BTN_LATER' | translate" text
                      (onClick)="close()" />
            <p-button *ngIf="stage === 'pin'" [label]="'COMMON.RSA_MIGRATION.BTN_CONTINUE' | translate" icon="pi pi-arrow-right"
                      (onClick)="submitPin()" />
            <p-button *ngIf="stage === 'place'" [label]="'COMMON.RSA_MIGRATION.BTN_CONTINUE' | translate" icon="pi pi-arrow-right"
                      (onClick)="submitPlace()" />
            <p-button *ngIf="stage === 'secret'" [label]="'COMMON.RSA_MIGRATION.BTN_CONTINUE' | translate" icon="pi pi-arrow-right"
                      [disabled]="!secret.trim()" (onClick)="submitSecret()" />
            <p-button *ngIf="stage === 'message'" [label]="'COMMON.RSA_MIGRATION.BTN_OK' | translate" (onClick)="close()" />
        </div>
    </ng-template>
</p-dialog>
